import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './beingbusy.json';

const Beingbusy = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Explore time management, productivity, and work-life balance through English exercises. B2 level grammar, vocab, reading, and speaking practice."
            level="B2"
            title="Being Busy"
            image="/Images/busy.webp"
            seoTitle="Free English Lesson Plans: Being Busy"
            seoDescription="Explore time management, productivity, and work-life balance through English exercises. B2 level grammar, vocab, reading, and speaking practice."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Beingbusy;


